import { render, staticRenderFns } from "./Release550Sections.vue?vue&type=template&id=e0a97ce0&scoped=true&"
import script from "./Release550Sections.vue?vue&type=script&lang=js&"
export * from "./Release550Sections.vue?vue&type=script&lang=js&"
import style0 from "./Release550Sections.vue?vue&type=style&index=0&id=e0a97ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a97ce0",
  null
  
)

export default component.exports